import { Layers } from 'lucide-react';

export interface GroupingOption {
  value: string;
  label: string;
}

export interface GroupingMenuProps {
  options: GroupingOption[];
  selected: string;
  onChange: (value: string) => void;
}

export function GroupingMenu({ options, selected, onChange }: GroupingMenuProps) {
  return (
    <div className="flex items-center gap-1.5 text-xs text-text-secondary">
      <Layers size={13} className="text-text-muted flex-shrink-0" />
      <span className="hidden sm:inline text-[11px] text-text-muted">Agrupar:</span>
      <select
        value={selected}
        onChange={(e) => onChange(e.target.value)}
        className="bg-surface-secondary border border-border text-text-primary rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-brand-primary cursor-pointer"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} className="bg-surface text-text-primary">
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
